function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 .5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4A.5.5 0 014 .5zM6.5 14a6 6 0 100-12 6 6 0 000 12zm0-10a.5.5 0 01.5.5v4a.5.5 0 01-1 0v-4a.5.5 0 01.5-.5zm4.953-2.358a.5.5 0 10-.707.707l1.403 1.403a.5.5 0 10.707-.707l-1.403-1.403z",
  fill: "#8F90A6"
});

function SvgSlas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSlas;